const combinedReducers = (state = {}) => state;

export default combinedReducers;
